<div [formGroup]="formGroup" class="contents">
    <label class="block text-sm font-medium mb-1" [htmlFor]="inputSignature">{{ label }}
        <span class="text-rose-500">
            {{ esRequerido() ? '*' : '' }}
        </span>
    </label>

    <ng-select *ngIf="inputType == 'ngselect'" class="override" [id]="inputSignature" [items]="items"
        (blur)="blurEvent($event)" [formControlName]="controlName" [multiple]="multiple" [disabled]="disabled"
        [readOnly]="readOnly" [bindLabel]="bindLabel" [bindValue]="bindValue"
        (change)="onNgSelectChange($event)"></ng-select>


    <div class="relative">
        <textarea *ngIf="inputType == 'textarea'" class="form-textarea w-full" [id]="inputSignature"
            [formControlName]="controlName" (blur)="blurEvent($event)"
            [ngClass]="[formGroup.get(controlName)?.invalid && (formGroup.get(controlName)?.dirty || formGroup.get(controlName)?.touched) ? '!border-rose-300' : '']"
            [autocomplete]="autoComplete" [disabled]="disabled" [readOnly]="readOnly" [required]="required"
            [spellcheck]="spellCheck" (change)="onChange($event)" (input)="onInput($event)"></textarea>

        <input #numberInput *ngIf="['text','number','email','password'].includes(inputType)" class="form-input w-full"
            (blur)="blurEvent($event)"
            [ngClass]="{'!border-rose-300' : formGroup.get(controlName)?.invalid && (formGroup.get(controlName)?.dirty || formGroup.get(controlName)?.touched), '!pr-[2.375rem]': (iconPos == 'right' && icon), '!pl-[2.375rem]': (iconPos == 'left' && icon) }"
            [id]="inputSignature" [formControlName]="controlName" [type]="inputType" [autocomplete]="autoComplete"
            [disabled]="disabled" [readOnly]="readOnly" [required]="required" [spellcheck]="spellCheck"
            [inputMask]="inputMask" (change)="onChange($event)" (input)="onInput($event)"
            (wheel)="disableScroll($event,numberInput,inputType)" pattern="" />

        <input #numberInput *ngIf="['url'].includes(inputType)" class="form-input w-full" (blur)="blurEvent($event)"
            [ngClass]="{'!border-rose-300' : formGroup.get(controlName)?.invalid && (formGroup.get(controlName)?.dirty || formGroup.get(controlName)?.touched), '!pr-[2.375rem]': (iconPos == 'right' && icon), '!pl-[2.375rem]': (iconPos == 'left' && icon) }"
            [id]="inputSignature" [formControlName]="controlName" [type]="inputType" [autocomplete]="autoComplete"
            [disabled]="disabled" [readOnly]="readOnly" [required]="required" [spellcheck]="spellCheck"
            [inputMask]="inputMask" (change)="onChange($event)" (input)="onInput($event)"
            (wheel)="disableScroll($event,numberInput,inputType)" pattern="" />

        <input *ngIf="inputType == 'date'" class="form-input w-full" (blur)="blurEvent($event)"
            [ngClass]="{'!border-rose-300' : formGroup.get(controlName)?.invalid && (formGroup.get(controlName)?.dirty || formGroup.get(controlName)?.touched), '!pr-[2.375rem]': (iconPos == 'right' && icon), '!pl-[2.375rem]': (iconPos == 'left' && icon) }"
            [id]="inputSignature" [formControlName]="controlName" [type]="'text'" [disabled]="disabled"
            [readOnly]="readOnly" [required]="required" [spellcheck]="spellCheck" (change)="onChange($event)"
            (input)="onInput($event)" />

        <div *ngIf="icon"
            class="absolute top-0 flex items-center justify-center h-full w-[2.375rem] pointer-events-none"
            [ngClass]="{'right-0': iconPos == 'right', 'left-0': iconPos == 'left'}">
            <i class="fa-duotone text-slate-400" [ngClass]="icon" style="font-size: 1.2rem;"></i>
        </div>
    </div>

    <div *ngIf=" showError && (formGroup.get(controlName)?.invalid && (formGroup.get(controlName)?.dirty || formGroup.get(controlName)?.touched))"
        class="text-xs mt-1 text-rose-500">
        {{ generalError ? generalError : 'El valor no es correcto' }}
    </div>
</div>